<div class="modal bottom-left-modal" [id]="modalId" tabindex="-1" role="dialog" [attr.aria-labelledby]="getModalLabel()" aria-hidden="true" >
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div *ngIf="isSelectedTermsModal; then selectedTermsContent"></div>
        </div>
    </div>
</div>

<!-- Modal Header and Body for the Selected Terms Modal -->
<ng-template #selectedTermsContent>
    <div class="modal-header">
        <h5 class="modal-title" [id]="getModalLabel()">{{ 'selectedTerms' | i18next}}</h5>
        <a href="#" (click)="clearSelectedTerms($event);">{{ 'clearAll' | i18next}}</a>
        <button type="button" class="close" (click)="closeModal($event);" aria-label="Close">
            <span aria-hidden="true">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-circle-fill" viewBox="0 0 16 16">
                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z"/>
                  </svg>
            </span>
        </button>
    </div>
    <div *ngIf="terms" class="modal-body">
        <div class="row" [ngClass]="{'hidden': !major && !explode}">
            <div class="col-8"></div>
            <div *ngIf="explode" class="col-2 explode-col-header">{{ explodeColumnLabel }}</div>
            <div *ngIf="major" class="col-2 major-col-header">{{ majorColumnLabel }}</div>
        </div>
        <div *ngFor="let term of terms; index as i">
            <div id="modal-term-wrapper-{{i}}" class="row">
                <div [ngClass]="(major || explode) ? 'col-8' : 'col-12' ">
                    <div *ngIf="isRelatedTerm(term.name)">
                        <input type="checkbox" name="term{{i}}" id="modal-term-{{i}}" value="{{term.name}}" [checked]="termsService.isRelatedChecked(term.name)" (click)="onRelatedCheckboxChange($event, term.name, term.paths)">
                        <label class="modal-term-label" for="modal-term-{{i}}">{{term.name}}</label>
                    </div>
                    <div *ngIf="!isRelatedTerm(term.name) && (!term.notUnique || (term.notUnique && isSingleInstanceSelected(term)))">
                        <input type="checkbox" name="term{{i}}" id="modal-term-main-{{i}}" [ngClass]="unSelectedParentTermOfQualifier(term.name, term.paths)" value="{{term.name}}" [checked]="termsService.isChecked(term.name, term.paths)" (click)="onCheckboxChange($event, term.name, term.paths)">
                        <label class="modal-term-label" for="modal-term-main-{{i}}">{{term.name}}</label>
                    </div>
                    <div *ngIf="!isRelatedTerm(term.name) && term.notUnique && !isSingleInstanceSelected(term)">
                        <div *ngFor="let path of term.paths"  class="row">
                            <div class="col-1"><input type="checkbox" name="term{{i}}" id="modal-term-main-{{i}}" [ngClass]="unSelectedParentTermOfQualifier(term.name, term.paths)" value="{{term.name}}" [checked]="termsService.isChecked(term.name, term.paths)" (click)="onCheckboxChange($event, term.name, term.paths)"></div>
                            <div class="col-11">
                                <label class="modal-term-label" for="modal-term-main-{{i}}">{{term.name}} <span class="small path-label"> {{getPathString(path, term)}}</span></label>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="explode" class="col-2 explode-input-label">
                    <input type="checkbox" name="term{{i}}" id="modal-term-explode-{{i}}" value="{{term.name}}" class="explodeChk" [checked]="termsService.isExplodeChecked(term.name, term.paths)" (click)="onExplodeCheckboxChange($event, term.name, term.paths)">
                    <label for="modal-term-explode-{{i}}" class="sr-only">{{term.name}}</label>
                </div>
                <div *ngIf="major" class="col-2 major-input-label">
                    <input type="checkbox" name="term{{i}}" id="modal-term-major-{{i}}" value="{{term.name}}" class="majorChk" [checked]="termsService.isMajorChecked(term.name, term.paths)" (click)="onMajorCheckboxChange($event, term.name, term.paths)">
                    <label for="modal-term-major-{{i}}" class="sr-only">{{term.name}}</label>
                </div>
            </div>
            <div *ngIf="termsService.hasQualifiers(term.name)">
                <div class="row qualifier-wrapper">
                    <div class="col-1"></div>
                    <div class="col-11 small">
                        <div class="qualifier-header">{{ 'qualifiers' | i18next}}:</div>
                        <div class="qualifier-list">
                            <div *ngFor="let qualifier of term.qualifiers; index as i">
                                <input type="checkbox" name="qualifier{{i}}" id="modal-term-qual-{{i}}" value="{{qualifier.name}}" class="majorChk" [checked]="termsService.isQualifierTermChecked(qualifier.name, term.name)" (click)="onQualifierCheckboxChange($event, qualifier.name, i, term.name)">
                                <label for="modal-term-qual-{{i}}">{{qualifier.name}}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>  
    </div>
</ng-template>